export enum PitchUploadStep {
  upload = 'upload',
  preview = 'preview',
  design = 'design',
}
